import sportsSchools from '@/store/modules/sports-schools'
import sportSchoolEdit from '@/store/modules/sports-schools-edit'
import sportSchoolDelete from '@/store/modules/sports-schools-delete'
import branchCreate from '@/store/modules/branch-create'
import branchEdit from '@/store/modules/branch-edit'
import branchDelete from '@/store/modules/branch-delete'
import sportsFederations from '@/store/modules/sports-federations'
import sportFederationEdit from '@/store/modules/sports-federations-edit'
import sportFederationDelete from '@/store/modules/sports-federations-delete'
import sportsClubs from '@/store/modules/sports-clubs'
import sportClubEdit from '@/store/modules/sports-clubs-edit'
import sportClubDelete from '@/store/modules/sports-clubs-delete'
import faqs from '@/store/modules/faqs'

export default {
  sportsSchools,
  sportSchoolEdit,
  sportSchoolDelete,
  branchCreate,
  branchEdit,
  branchDelete,
  sportsFederations,
  sportFederationEdit,
  sportFederationDelete,
  sportsClubs,
  sportClubEdit,
  sportClubDelete,
  ...faqs,
}
